// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Title-module__lineClamp___XtXj6{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}
`, "",{"version":3,"sources":["webpack://./node_modules/mintel-react-ui/dist/package/Title2.css"],"names":[],"mappings":"AAAA,iCAAiC,mBAAmB,CAAC,2BAA2B,CAAC,eAAe,CAAC,sBAAsB","sourcesContent":[".Title-module__lineClamp___XtXj6{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
